import React, { Component } from 'react';

import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';

import SelectOption from '../../components/Inputs/Select/Select';
import Toast from '../../components/Toast/Toast';

import CidadeService from '../../services/Cidade';
import { patternRegion } from '../../variables/Enums/Cidade';

import { 
    isBlank, 
    isBlankHelperText,
} from '../../helper/ValidationHelper';

export class Regiao extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {            
            region: '',
            errors: {
                region: false,
            },
            helpers: {
                region: null,
            },
            disabled: {
                region: false,
            },
            required: {
                region: true,
            },
            optionsRegion: [],
            loadingOptionsRegion: false,
        }
    }

    // INPUTS
    handleChange = e => {
        this.setState({ 
            ...this.state,
            [e.target.name]: e.target.value,
            errors: { ...this.state.error, [e.target.name]: false, },
            helpers: { ...this.state.helper, [e.target.name]: null, },
        });
    }

    // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES
    setToast = t => this.Toast = t;

    carregarRegioes = () => {
        this.setState({ loadingOptionsRegion: true });

        CidadeService.filterRegioes([])
            .then(res => {
                this.setState({
                    region: this.state.region,                    
                    optionsRegion: [...patternRegion(res.data.content, this.props.withRegionRJ04)]
                })
            })
            .catch(err => {
                this.Toast.setState({
                    message: {
                        message: "Não Foi Possível Buscar as Regiões.",
                        type: 'error',
                        open: true
                    }
                })
            })
            .finally(() => this.setState({ loadingOptionsRegion: false }))
    }

    isValid = () => {
        const regionBlank = isBlank(this.state.region);        
        
        if (regionBlank) {
            this.setState({ 
                errors: {
                    region: regionBlank,
                },
                helpers: {
                    region: regionBlank ? isBlankHelperText() : null,
                },
            });
            return false;
        }
        return true;
    }

    componentDidMount () {
        this.carregarRegioes();
    }

    render () {
        return (
            <>
                <Toast parentRef={this.setToast} />
                
                <SelectOption
                    required={this.state.required.region}
                    label="Região"
                    name='region'
                    value={this.state.region}
                    onChange={this.handleChange}
                    options={this.state.optionsRegion}
                    disabled={this.state.loadingOptionsRegion || this.state.disabled.region}
                    InputProps={{
                        startAdornment: this.state.loadingOptionsRegion ? <InputAdornment position="start"><CircularProgress size={18} /></InputAdornment> : null,
                    }}
                    error={this.state.errors.region}
                    helperText={this.state.helpers.region}
                />
            </>
        )
    }
}

export default Regiao;
